import React from 'react';
import { motion } from 'framer-motion';
import { GitBranch, GitMerge, Clock, ChevronRight } from 'lucide-react';
import { Badge } from '../ui/Badge';
interface Branch {
  id: string;
  name: string;
  status: 'active' | 'merged' | 'archived';
  type: 'exploratory' | 'alternative' | 'rollback';
  created: string;
  stats: string;
  source: string;
}
export function BranchHistoryPanel() {
  const branches: Branch[] = [{
    id: '1',
    name: 'try-redis-approach',
    status: 'active',
    type: 'alternative',
    created: '2h ago',
    stats: '4 nodes',
    source: 'Implement caching'
  }, {
    id: '2',
    name: 'quick-fix-auth',
    status: 'merged',
    type: 'exploratory',
    created: '1d ago',
    stats: 'Merged',
    source: 'Auth setup'
  }, {
    id: '3',
    name: 'old-schema',
    status: 'archived',
    type: 'rollback',
    created: '3d ago',
    stats: 'Archived',
    source: 'Schema design'
  }];
  return <div className="w-80 border-l border-surface-600 bg-surface-900 flex flex-col h-full">
      <div className="p-4 border-b border-surface-600">
        <h3 className="font-semibold text-text-primary">Branch History</h3>
        <div className="flex gap-2 mt-3">
          {['All', 'Active', 'Merged'].map(filter => <button key={filter} className="text-xs px-2 py-1 rounded bg-surface-800 text-text-secondary hover:text-text-primary hover:bg-surface-700 transition-colors">
              {filter}
            </button>)}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {branches.map(branch => <motion.div key={branch.id} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="p-3 rounded-lg bg-surface-800/50 border border-surface-600 hover:border-surface-500 transition-colors group cursor-pointer">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <GitBranch className={`w-4 h-4 ${branch.status === 'active' ? 'text-primary-400' : branch.status === 'merged' ? 'text-success-400' : 'text-text-muted'}`} />
                <span className="font-medium text-sm text-text-primary">
                  {branch.name}
                </span>
              </div>
              <Badge variant={branch.status === 'active' ? 'primary' : branch.status === 'merged' ? 'success' : 'secondary'} className="text-[10px] px-1.5 py-0">
                {branch.status}
              </Badge>
            </div>

            <div className="text-xs text-text-muted space-y-1">
              <div className="flex items-center gap-1">
                <Clock className="w-3 h-3" />
                <span>{branch.created}</span>
              </div>
              <div className="flex items-center gap-1">
                <GitMerge className="w-3 h-3" />
                <span>From: {branch.source}</span>
              </div>
            </div>

            <div className="mt-3 pt-2 border-t border-surface-600 flex justify-between items-center opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-xs text-text-muted">{branch.stats}</span>
              <ChevronRight className="w-4 h-4 text-text-muted" />
            </div>
          </motion.div>)}
      </div>
    </div>;
}